// Export all UI components
export * from './ui';

// Export all layout components
export * from './layout';

// Export all form components
export * from './forms';

// Export all admin components
export * from './admin';

// Export all common components

// Individual component exports for backwards compatibility
export { Button } from './ui';
export { Navbar, Footer } from './layout';
export { HomeHeroAnimation } from './HomeHeroAnimation'; 